import ExamSectionTemplate from '@/pages/ExamSectionTemplate';

const faqs = [
  {
    question: "What is CBERM certification?",
    answer: "CBERM (Competency-Based Examination in Regenerative Medicine) validates competency in regenerative and cellular medicine, including PRP therapies, biostimulators, tissue regeneration, and emerging cellular applications, with strong emphasis on safety, ethics, and regulatory compliance."
  },
  {
    question: "Why does CBERM have special regulatory emphasis?",
    answer: "Cellular and regenerative therapies face evolving regulatory frameworks globally. CBERM places significant emphasis on regulatory awareness because practitioners must ensure their practice complies with local laws governing cellular therapies, stem cell treatments, and biological interventions."
  },
  {
    question: "What procedures are covered in CBERM?",
    answer: "CBERM covers PRP (Platelet-Rich Plasma) therapies, growth factor applications, biostimulators (polynucleotides, PLLA, etc.), tissue regeneration techniques, and the ethical and regulatory frameworks surrounding cellular therapies."
  },
  {
    question: "Does CBERM certification authorize stem cell treatments?",
    answer: "No, CBERM certification validates assessed competencies but does not authorize any therapy not approved by your national regulatory authority. Practitioners must ensure full compliance with local laws governing cellular and regenerative therapies in their jurisdiction."
  },
  {
    question: "What are the eligibility requirements for CBERM?",
    answer: "CBERM requires valid medical registration, minimum 3 years post-licensure clinical experience (higher than other certifications due to complexity), evidence of regenerative medicine training, demonstrated understanding of regulatory frameworks, and current professional indemnity insurance."
  },
  {
    question: "How does recertification work for CBERM?",
    answer: "CBERM recertification every 5 years requires minimum 25 CPD hours annually in regenerative medicine, evidence of continued clinical practice and regulatory compliance, updated regulatory awareness assessment, and annual regulatory compliance declaration."
  }
];

export default function RegenerativeMedicinePage() {
  return (
    <ExamSectionTemplate
      sectionTitle="Section 3: Regenerative & Cellular Medicine"
      examCode="CBERM"
      ipcfBadge="Level 6 Practitioner Certification"
      examFullName="Competency-Based Examination in Regenerative Medicine"
      testIdPrefix="cberm"
      fee="₹35,000"
      faqs={faqs}
      overview="CBERM evaluates competency in regenerative and cellular medicine, including PRP therapies, biostimulators, tissue regeneration, and emerging cellular applications. Given the evolving regulatory landscape of cellular therapies, this examination places significant emphasis on safety, ethics, and regulatory compliance."
      eligibility={[
        'Valid medical registration in home jurisdiction',
        'Minimum 3 years post-licensure clinical experience',
        'Evidence of training or practice in regenerative medicine',
        'Demonstrated understanding of cellular therapy regulatory frameworks',
        'Professional references from two registered medical practitioners',
        'Current professional indemnity insurance',
      ]}
      stages={[
        { title: 'Written Examination', desc: 'Comprehensive written examination covering regenerative science, applications, and regulatory frameworks.' },
        { title: 'Simulation-Based OSCE', desc: 'Clinical simulation stations testing procedural competency in regenerative techniques.' },
        { title: 'Case Log Review', desc: 'Verified clinical case log demonstrating experience across regenerative procedure categories.' },
        { title: 'Viva Defense', desc: 'Oral examination assessing clinical reasoning, ethical decision-making, and regulatory awareness.' },
      ]}
      coreDomains={[
        'PRP & Growth Factors',
        'Biostimulators',
        'Tissue Regeneration',
        'Cellular Therapy Ethics',
        'Regulatory Compliance',
      ]}
      certificationValidity={[
        'Initial certification valid for 5 years from date of issue',
        'Certificate verifiable through IMCAC public verification portal',
        'Certification title: Board Certified in Regenerative Medicine (IMCAC – CBERM)',
        'Certification may be revoked for non-compliance with CPD, ethics, or regulatory requirements',
        'Annual regulatory compliance declaration required',
      ]}
      recertificationPolicy={[
        'Recertification required every 5 years',
        'Minimum 25 CPD hours per year in regenerative medicine activities',
        'Evidence of continued clinical practice and regulatory compliance',
        'Updated regulatory awareness assessment',
        'Compliance audit by IMCAC CPD Committee',
      ]}
      additionalDisclaimer="Cellular therapies are subject to strict regulatory oversight in many jurisdictions. IMCAC certification in regenerative medicine does not authorise the practice of any therapy not approved by the candidate's national regulatory authority. Candidates must ensure full compliance with local laws governing cellular and regenerative therapies, including but not limited to stem cell treatments, exosome therapies, and advanced biological interventions."
      disclaimer="Certification validates assessed competencies within regenerative medicine and does not grant medical licensure. Candidates must hold valid professional registration in their jurisdiction."
      applyLink="/apply"
    />
  );
}
